<template>
  <header-app back="true" titlepage="یزد گیشه - لیست کاربران در حال خرید"></header-app>
  <v-main class="main">
    <div class="col-12 col-md-6 float-right item" v-for="(cat, index)  in program" :key="index">
      <div class="divItem">
        <h2>نام برنامه : {{ cat.name }}</h2>
        <v-divider/>
        <h3>سانس  : {{ cat.date_persian }}</h3>
        <v-divider/>
        <h3>جایگاه : {{ cat.sec }}</h3>
        <v-divider/>
        <h3>ردیف : {{ cat.char_row }}</h3>
        <v-divider/>
        <h3>شماره صندلی	 : {{ cat.char_no }}</h3>
        <v-divider/>
        <h3>تاریخ ثبت		 : {{ cat.insdate }}</h3>


      </div>
    </div>
  </v-main>
  <footer-app selectedItem="1"></footer-app>
</template>


<script>


import {defineComponent} from "vue";
import HeaderApp from "@/views/headerApp.vue";
import FooterApp from "@/views/FooterApp.vue";
import DataView from "@/views/DataView.vue";
import router from "@/router";
import http from "@/plugins/axios";
import {CurvedBottomNavigation} from "bottom-navigation-vue";
import {th} from "vuetify/locale";

export default {
  name: 'user-sales',
  components: {DataView, FooterApp, HeaderApp},
  data: () => ({
    program: [],
    page: 0,
    get_next_page: false,
    urlUpload: "",
    length: 10
  }),
  methods: {
    click(program_id) {
      router.push("/sans/" + program_id)
    },
    getData(pages) {
      const AuthStr = (localStorage.getItem("token"));
      http.post("/reservations.php", {
            length: this.length,
            start: pages
          },
          {headers: {Token: AuthStr}})
          .then(response => {
            console.log(response.data);
            if (response.data.code != "200") {
              let dataP = response.data;
              this.urlUpload = response.data.urlUpload;
              dataP.massege.forEach((item) => {
                this.program.push(item);
              });
              this.get_next_page = true;
            } else {
              // alert("1");
            }

          });
    },
    fetchNextProducts() {
      window.onscroll = () => {

        let bottomOfWindow = $(window).scrollTop() + $(window).height() - $(document).height();

        if (bottomOfWindow > this.diffFromBottom) {

          // console.log(bottomOfWindow);
          // console.log(this.diffFromBottom);
          if (this.get_next_page) {
            this.get_next_page = false;
            this.page++;
            this.getData(this.page);
          }
        }
      }
    },
  },
  computed: {
    diffFromBottom() {
      let diff = -1200;
      diff = -1900;
      return diff;
    },
  },
  mounted() {
    this.getData();
    this.fetchNextProducts();
  },
}
</script>


<style scoped>
.item {
  padding: 10px;
  text-align: center;
  direction: rtl;
}

.divItem h2 {
  padding-top: 10px;
}

.item .divItem {
  overflow: hidden;
  border-radius: 10px;
  border: 2px solid #e8e8e8;
  background: #e8e8e8;
}
</style>